/**
 * Checks whether a child element of the provided element is overflowing its parent.
 */
export function isChildOverflowing(element: HTMLElement | HTMLElement[]): boolean {
  const parent = Array.isArray(element) ? element[0] : element
  const child = parent?.firstChild as HTMLElement | null
  if (child) {
    return (
      child.offsetWidth > parent.offsetWidth ||
      child.offsetHeight > parent.offsetHeight
    )
  }
  return false
}

/**
 * Checks for element in DOM, and if not found, waits for element to be added.
 * @returns Promise that resolves when element is available in DOM
 */
export function waitForElement(selector: string): Promise<Element> {
  return new Promise((resolve) => {
    const existing = document.querySelector(selector)
    if (existing) {
      return resolve(existing)
    }

    const observer = new MutationObserver(() => {
      const found = document.querySelector(selector)
      if (found) {
        resolve(found)
        observer.disconnect()
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  })
}
